import React from 'react';
import { string, bool, func } from 'prop-types';
import { Row, Column, Text, AppIcon, Divider, HasPermissions } from '../../common';

const ChildrenCategory = ({ label, value, withDivider, onClickEdit }) => (
    <>
        <Row>
            <Column flex={4}>
                <Text text={label} size={12} />
            </Column>
            <Column align='flex-end'>
                <Text text={value} size={12} semibold />
            </Column>
            <HasPermissions to={['categories-page:edit']}>
                <Column align='flex-end'>
                    <AppIcon name='ic-edit' size='12' style={{ cursor: 'pointer' }} onClick={onClickEdit} />
                </Column>
            </HasPermissions>
        </Row>
        { withDivider && <Divider padding={8} /> }
    </>
);

ChildrenCategory.propTypes = {
    label: string,
    value: string,
    withDivider: bool,
    onClickEdit: func
};

ChildrenCategory.defaultProps = {
    label: '',
    value: '',
    withDivider: false,
    onClickEdit: () => {}
};

export default ChildrenCategory;
